// Ventas por método del asistente de cierre (H58). El backend las manda solo al
// Administrador: el Operador cuenta a ciegas. Filas ordenadas, con «Nota de crédito»
// (CREDIT_NOTE) al final, que es lo que se pagó con saldo a favor y no entró como dinero.
export function salesByMethodRows(byMethod) {
    if (!byMethod || typeof byMethod !== 'object') return [];
    return Object.entries(byMethod)
        .map(([code, row]) => ({ code, total: row.total, count: row.count }))
        .sort((a, b) => (a.code === 'CREDIT_NOTE') - (b.code === 'CREDIT_NOTE') || a.code.localeCompare(b.code));
}
